module.exports = __webpack_public_path__ + "static/media/announce_02.2157e899.jpg";